// Bundle the local HTML document as a static asset.
// eslint-disable-next-line import/no-webpack-loader-syntax
import aiUsageUrl from '!!file-loader!../Learn/articles/ai-usage.html';

export const articleCategories = ['Using AI'] as const;

export type ArticleCategory = typeof articleCategories[number];

export interface Article {
  slug: string;
  contentUrl: string;
  title: string;
  description: string;
  category: ArticleCategory;
  /** Publication date in YYYY-MM-DD format. */
  date: string;
}

// Add published articles here, newest first.
export const articles: Article[] = [{
  slug: 'ai-usage',
  contentUrl: aiUsageUrl,
  title: 'Beyond "Just Google It": How to Master AI Prompts, Save Tokens, and Get Better Answers',
  description: 'Learn practical strategies for managing AI chat context, crafting better prompts, and reviewing AI-generated answers.',
  category: 'Using AI',
  date: '2026-09-08',
}];
